import {AccessRights} from "../../constants";
import {arrayToSet} from '../../atUtils'
import {ManagementAssignmentsSelection, UserManagementConstants} from 'constants'

export function convertManagementAssignmentsDataFromRpc(rpcData) {
    return {
        managementAssignmentsSelection: rpcData.managementAssignmentsSelection,
        customers: rpcData.customers.map,
        projects: rpcData.projects.map,
        tasks: rpcData.tasks.map,
        customerAssignments: rpcData.customerAssignments,
        projectAssignments: rpcData.projectAssignments,
        taskAssignments: rpcData.taskAssignments,
        taskCountsByProjects: rpcData.taskCountsByProjects.map,
        projectCountsByCustomers: rpcData.projectCountsByCustomers.map,
        managementAssignmentsCounters: rpcData.managementAssignmentsCounters
    }
}

export function convertUserAccessRightsDataFromRpc(rpcData) {
    const rights = [];
    if (rpcData['hasManageUsersRight']) {
        rights.push(AccessRights.MANAGE_USERS);
    }
    if (rpcData['hasManageOtherTTRight']) {
        rights.push(AccessRights.SUBMIT_OTHER_USER_TIME_TRACK);
    }
    if (rpcData['hasManageScopeRight']) {
        rights.push(AccessRights.EDIT_HIERARCHY);
    }
    if (rpcData['hasGenerateMoneyReportsRight']) {
        rights.push(AccessRights.GENERATE_MONEY_REPORTS);
    }
    if (rpcData['hasSubmitTTRight']) {
        rights.push(AccessRights.SUBMIT_TIME_TRACK);
    }
    if (rpcData['hasLockTTRight']) {
        rights.push(AccessRights.LOCK_TIME_TRACK);
    }
    if (rpcData['hasManagePTOAndSickRight']) {
        rights.push(AccessRights.MANAGE_PTO_AND_SICK);
    }
    if (rpcData['hasManageSettingsRight']) {
        rights.push(AccessRights.MANAGE_GENERAL_SETTINGS);
    }
    return rights;
}

export const getTimeZoneOffsets = (timeZones) => {
    if (!timeZones) return {}

    return timeZones.reduce((result, item) => {
        if (item.rawOffset !== undefined)
            result[item.id] = item.rawOffset
        return result
    }, {})
}


// WEBPACK FOOTER //
// ./web/js/panels/user/utils.js